module.exports = __webpack_public_path__ + "6c7b5035.jpg";